module.exports = __webpack_public_path__ + "static/media/icon-user.ed52f187.svg";